<div class="container">
  <div class="row space-between">
    <div class="col-md-2">
      <button mat-flat-button class="nav-button filter" (click)="openFilterModal()" matTooltip="Set pipeline filters"><i class="material-icons" style="font-size: 16px">filter_alt</i></button>
      <button mat-flat-button class="nav-button refresh" matTooltip="Refresh" (click)="refreshPipelineData()"><i class="material-icons" style="font-size: 16px">update</i></button>
      @if(((pipelineService.sections$ | async)??[]).length > 0){
        <button mat-flat-button class="nav-button export" (click)="openExportModal()" matTooltip="Export pipeline"><i class="material-icons">download</i></button>
        <button mat-flat-button class="nav-button quick-export" matTooltip="Quick export" (click)="quickExport()"><i class="material-icons">redo</i></button>
      }
    </div>
    <div class="col-md-1">
<!--      <button mat-flat-button class="nav-button help" matTooltip="Show help"><i class="material-icons" style="font-size: 16px">question_mark</i>Help</button>-->
    </div>
  </div>
  @if(isLoaded){
    <h1 class="pipeline-header">{{ (pipelineService.pipelineName$ | async) ?? 'New Pipeline' }}</h1>
    <div class="totals-row">
      @for(value of (pipelineService.topTotals$ | async); track $index){
        <span>
          <div class="total-row-name">{{value.name}}</div>
          |
          @if(value.format==null){
            <div class="total-row-value">{{value.value}}</div>
          }
          @if(value.format=='nfcurrency'){
            <div class="total-row-value">{{value.value | currency: 'USD' : 'symbol' : '1.0-0'}}</div>
          }
          @if(value.format=='currency'){
            <div class="total-row-value">{{value.value | currency: 'USD': 'symbol': '1.4-4'}}</div>
          }
          @if(value.format=='percentage'){
            <div class="total-row-value">{{value.value}}%&nbsp;</div>
          }
        </span>
      }
    </div>
    @if((pipelineService.globalViewFilters$ | async)?.length){
      <div class="row">
        <div class="show-pipeline-list-btn" (click)="showHidePipelinesList()">Select Pipeline<i class="material-icons">{{showPipelinesSelectionList ? 'arrow_drop_up' : 'arrow_drop_down'}}</i></div>
      </div>
      @if(showPipelinesSelectionList){
        <pipelines-selection-panel
          [globalViews]="(pipelineService.globalViewFilters$ | async) ?? []"
          [ownedViews]="(pipelineService.ownedViewFilters$ | async) ?? []"
          [sharedViews]="(pipelineService.sharedViewFilters$ | async) ?? []"
          [investorView]="(pipelineService.investorViewFilters$ | async) ?? []"
        ></pipelines-selection-panel>
      }
    }
    @for(section of (pipelineService.sections$ | async); track section.index){
      <h3>{{section.name}}</h3>
      <div class="totals-row">
        @for(value of section.totals; track $index){
          <span>
            <div class="total-row-name">{{value.name}}</div>
            |
            @if(value.format==null){
              <div class="total-row-value">{{value.value}}</div>
            }
            @if(value.format=='nfcurrency'){
              <div class="total-row-value">{{value.value | currency: 'USD' : 'symbol' : '1.0-0'}}</div>
            }
            @if(value.format=='currency'){
              <div class="total-row-value">{{value.value | currency: 'USD': 'symbol': '1.4-4'}}</div>
            }
            @if(value.format=='percentage'){
              <div class="total-row-value">{{value.value}}%&nbsp;</div>
            }
          </span>
        }
      </div>
      <pipelines-table [projects]="section.projects"></pipelines-table>

    }
  }
</div>
